import server from '@/request';

// 提交图片
export const uploadImg = (data) => {
  return server.post('http://upload.qiniup.com', data);
};
